import { render, staticRenderFns } from "./SecondaryUsageFeeForBroadcastsTermsReminderDialog.vue?vue&type=template&id=210ecaf5&scoped=true&"
import script from "./SecondaryUsageFeeForBroadcastsTermsReminderDialog.vue?vue&type=script&lang=js&"
export * from "./SecondaryUsageFeeForBroadcastsTermsReminderDialog.vue?vue&type=script&lang=js&"
import style0 from "./SecondaryUsageFeeForBroadcastsTermsReminderDialog.vue?vue&type=style&index=0&id=210ecaf5&scoped=true&lang=css&"
import style1 from "./SecondaryUsageFeeForBroadcastsTermsReminderDialog.vue?vue&type=style&index=1&id=210ecaf5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210ecaf5",
  null
  
)

export default component.exports